import React from "react";
import PropTypes from "prop-types";

import { Header } from "semantic-ui-react";

export function Tab({ visible, slideOut, ...props }) {
  if (!visible) return null;

  const { title, open, icon, children, onClick, ...others } = props;

  // compositor-only slide: 45px covers the 40px tab plus borders/shadow
  const closedTabTransform = slideOut
    ? "translate3d(45px, 0, 0)"
    : "translate3d(0, 0, 0)";

  return (
    <div
      {...others}
      className="clickable grey_on_hover"
      style={{
        marginRight: "0px",
        borderLeft: "1px solid rgba(34,36,38,.15)",
        borderRight: "2px solid rgba(34,36,38,.15)",
        borderTopRightRadius: "0px",
        borderBottomRightRadius: "0px",
        width: "40px",
        height: open ? "calc(100% + 13px)" : "calc(100% - 47px)",
        position: "fixed",
        top: open ? "0px" : "47px",
        transform: open ? "translate(-40px, 0px)" : closedTabTransform,
        float: !open ? "right" : "",
        backgroundColor: "white",
        right: !open ? "0px" : "",
        zIndex: 102,
        boxShadow: "-2px 0px 2px rgba(34,36,38,.15)",
        // closed tab only: shares the hub-feed 280ms exit clock/curve;
        // visibility flips only after the slide (instantly on the way
        // back) so the tab is out of reach while tucked away. The open
        // tab keeps inheriting the sidebar's own visibility.
        ...(open
          ? {}
          : {
              transition: slideOut
                ? "transform 280ms cubic-bezier(0.4, 0, 0.2, 1), visibility 0s linear 280ms"
                : "transform 280ms cubic-bezier(0.4, 0, 0.2, 1), visibility 0s",
              visibility: slideOut ? "hidden" : "visible",
              pointerEvents: slideOut ? "none" : "auto",
            }),
      }}
      onClick={onClick}
    >
      <div style={{ margin: "auto", width: "min-content", marginTop: "1em" }}>
        {icon}
      </div>
      <div style={{ transform: "rotate(-90deg)", marginTop: "4em" }}>
        <Header as="h3" style={{ width: "max-content" }}>
          {title}
        </Header>
      </div>
      <div
        style={{
          width: "100%",
          marginTop: "1.25em",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {children}
      </div>
    </div>
  );
}

Tab.propTypes = {
  title: PropTypes.string,
  open: PropTypes.bool,
  visible: PropTypes.bool,
  slideOut: PropTypes.bool,
  children: PropTypes.node,
  icon: PropTypes.node,
  onClick: PropTypes.func.isRequired,
};

Tab.defaultProps = {
  title: "Feed",
  visible: true,
  open: false,
  slideOut: false,
  icon: null,
  children: null,
};

export default Tab;
